import { Trans, useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useStore } from '@stores/RootStore';
import { useGetApprovals } from '@queryHooks/useApproval';
import * as S from './ApprovalMgmtListStyles';

export const ApprovalMgmtList = () => {
  const { t } = useTranslation();
  const { authStore } = useStore();
  const { data: pendingApprovals, isFetching } = useGetApprovals({
    approverId: authStore.id,
    stepStatus: 'IN_PROGRESS',
  });

  const totalApprovalCount = pendingApprovals?.content.length ?? 0;

  const tabList = [
    { name: t('Approval_Tab_Pending'), path: 'pending' },
    { name: t('Approval_Tab_Completed'), path: 'completed' },
  ];

  if (isFetching) return <CircularProgress />;

  return (
    <S.Container>
      <S.Header>
        <p>
          <Trans
            i18nKey="Approval_Mgmt_Title"
            values={{ Name: authStore.name, number: totalApprovalCount }}
            components={{ 1: <strong />, 2: <br />, 3: <strong className="count" /> }}
          />
        </p>
      </S.Header>
      <S.Body>
        <S.StyledRoutingTabs className="approval_tab" tabList={tabList} variant="contain" />
        <Outlet />
      </S.Body>
    </S.Container>
  );
};
